import {AnimatePresence, motion} from "framer-motion"
import React from "react"

import styles from "./HomeHeroAnimated.module.scss"
import LaptopSvg from "./LaptopSvg"

interface LaptopScreenProps {
	imageSrc?: string
}

const LaptopScreen: React.FC<LaptopScreenProps> = ({imageSrc}) => {
	return (
		<div
			style={{
				position: "absolute",
				right: "5%",
				top: "50%",
				transform: "translateY(-50%)",
				zIndex: 2,
				height: "auto",
				width: "37%",
				maxWidth: "100%",
				pointerEvents: "none",
			}}
			className={styles.laptopScreen}
		>
			<LaptopSvg
				style={{
					width: "100%",
					height: "auto",
					display: "block",
				}}
			/>

			<AnimatePresence mode={"sync"}>
				{imageSrc && (
					<motion.img
						key={imageSrc}
						src={imageSrc}
						alt={"Decorative element"}
						initial={{opacity: 0}}
						animate={{opacity: 1}}
						exit={{opacity: 0}}
						transition={{duration: 0.4, ease: "easeInOut"}}
						style={{
							position: "absolute",
							bottom: "1px",
							left: "1px",
							width: "calc(87% - 1px)",
							height: "auto",
							borderRadius: "0 0 9px 9px",
							objectFit: "cover",
						}}
					/>
				)}
			</AnimatePresence>
		</div>
	)
}

export default LaptopScreen
